<template>
  <div class="kanban">
    <img style="width: 100%;" :src="url" alt="" />
    <!-- <span class="son" @click="handleFullScreen"></span> -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      list: ['碳排总览-版本2@1x','碳排监测@1x','碳资产管理@1x','碳足迹管理-版本2@1x','ESG报告@1x', '平台生态@1x',    ],
      fullscreen: false,
      url: '',
    };
  },
  watch: {
    memo(nv, ov) {
      if (nv) {
        this.url = require("@/assets/airportTopMenu/" + nv + ".png");
      } else {
        // this.url = require("@/assets/airportTopMenu/" + this.list[0] + ".png");
      }
    },
  },
  mounted() {
    var nv = this.$store.menuStore.state.nowMenu.memo;
    if (nv) {
      this.url = require("@/assets/airportTopMenu/" + nv + ".png");
    } else {
      this.url = require("@/assets/airportTopMenu/" + this.list[this.$route.query.i] + ".png");
    }
  },
  methods: {
    // 全屏事件
    handleFullScreen() {
      // 此处可根据获取节点进行区域全屏事件
      let element = document.getElementsByClassName("kanban")[0];
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
  },
};
</script>
<style scoped>
.son {
  position: absolute;
  display: block;
  width: 40px;
  height: 40px;
  top: 36px;
  right: 25px;
  cursor: pointer;
}

.kanban {
  width: 100%;
  padding: 0 !important;
  position: fixed;
  height: 100vh !important;
  top: 0;
  margin: 0;
  background: #010101 !important;
}

/* 隐藏垂直滚动条 */
.kanban::-webkit-scrollbar {
  width: 0;
}

.xingqi {
  margin: 0 10px;
  font-size: 17px;
  font-weight: bold;
}

.my-timer {
  position: absolute;
  top: 42px;
  color: #fff;
  display: flex;
  left: 28px;
  background: #000;
  font-size: 17px;
  padding: 10px;
  font-weight: bold;
  align-items: center;
}

#my_iframe {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 0;
  background: #333;
  margin: 0px;
}

/*body {*/
/*    overflow: hidden;*/
/*    margin: 0px;*/
/*}*/

.left {
  position: absolute;
  z-index: 2;
  background-color: #000;
  padding: 1em;
  width: 400px;
}

#layer {
  width: 1px;
  height: 1px;

  z-index: 99;
  position: absolute;
  color: #fff;
}

#text {
  width: 100px;
  height: 100px;
  background: #00000066;
  position: relative;
  top: -120px;
  left: -50px;
  border: 2px solid #111;
  border-radius: 5px;
  padding: 0.5em;
}
</style>
